import React from "react";

import { mediaQueriesV2 } from "@ui/themes/default";

import { useTranslate } from "@hooks/useTranslate";

import imageDesktop from "../assets/hero_desktop.webp";
import imageTablet from "../assets/hero_tablet.webp";
import imageMobileLarge from "../assets/hero_mobile_large.webp";
import imageMobile from "../assets/hero_mobile.webp";

import * as Styled from "./Image.styled";

const base64 =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAXCAYAAABqBU3hAAAAAXNSR0IArs4c6QAAAf9JREFUSEu1Vll2wzAIFPe/RZMmN2i2G3Rfr2P3gQAB2vraNB9x7GBpxAwDsDl8rIk+QN90s+bf8pwDzDMXnRKsCfBNvgLgG0uiq3tW7nX1AiBsGEAoOA+VIAPhxStujNelDcbE5t3WBJvj+5qP3Tm1A+KS4DavsxBBFIAYKzvC9vimFGiqexRggMFJaaeV/kDB9vSaV+llYZQB2phfnvKPmrCxTMHt6cVorC/ErgYMiLb4ChWaKQWdEuzOz1n4Qm8r/VV2UM2mEgIFRfmNzSVWamx3fmpUGbNbbXw9EYqUYH95LIcfaaHmINd+T4Sw0P+uNFGvXKpahvvLQ8hA7/S2TK1sfAW00l9AZJ/IMYx9f7l3TsiP2RGjPwQKDJ9TE9LYYly0+hAApd2e3AIQIbKpNO23J8LCJ9QU5FPXPSEKUAyI61ltGIFZ/n1PsNbNGRANWA+IqVe5Zc1JHVsBiuCsIVVCbGhgh1XQLLdJKTZc8CfdsKqC7APuTNN2fNUMeCu2/E8qQNMfNRC6INMQG5YoCqgZ/QcFQyFyFaCdb3EecL1gLEBFLkJ09R0moKkIcSDRkawsXRD1PEBsrLTjthHVQ4nviCnBzeGz+OpwMjI+YDuh8XfbjodzIdlxlj7c3H39shtaJ+SmMxxKFj/CMYUBgDGcyoKFDot3NpDO54Fv3DTVHdY1LgQAAAAASUVORK5CYII=";

export const Image: React.FC = () => {
  const translate = useTranslate("batmaid_pwa_static_homepage");

  return (
    <Styled.Root>
      <Styled.Image
        width={3800}
        height={2929}
        src={imageMobile}
        alt={translate("hero_image_alt")}
        base64={base64}
        loading="eager"
        objectFit="cover"
        sources={[
          {
            media: mediaQueriesV2.largeMobile,
            srcSet: imageMobileLarge,
          },
          {
            media: mediaQueriesV2.smallTablet,
            srcSet: imageTablet,
          },
          {
            media: mediaQueriesV2.tablet,
            srcSet: imageTablet,
          },
          {
            media: mediaQueriesV2.smallDesktop,
            srcSet: imageDesktop,
          },
          {
            media: mediaQueriesV2.desktop,
            srcSet: imageDesktop,
          },
          {
            media: mediaQueriesV2.largeDesktop,
            srcSet: imageDesktop,
          },
        ]}
      />
    </Styled.Root>
  );
};
